module.exports = __webpack_public_path__ + "img/19_75.14acbc72.png";